var React = require('react');

function BlogAuthor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#696969;}")),React.createElement("path",{"className":"a","d":"M13.81,9.522A7.026,7.026,0,0,0,12.018,8.4a.586.586,0,1,0-.476,1.071,5.86,5.86,0,0,1,1.494.931,2.336,2.336,0,0,1,.791,1.756v1.084a.587.587,0,0,1-.586.586H1.758a.587.587,0,0,1-.586-.586V12.158A2.336,2.336,0,0,1,1.963,10.4,8.237,8.237,0,0,1,7.5,8.672a4.341,4.341,0,1,0-2.641-.9A8.146,8.146,0,0,0,1.19,9.522,3.508,3.508,0,0,0,0,12.158v1.084A1.76,1.76,0,0,0,1.758,15H13.242A1.76,1.76,0,0,0,15,13.242V12.158a3.508,3.508,0,0,0-1.19-2.636ZM4.336,4.336A3.164,3.164,0,1,1,7.5,7.5,3.168,3.168,0,0,1,4.336,4.336Z","key":1})]);
}

BlogAuthor.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = BlogAuthor;

BlogAuthor.default = BlogAuthor;
